import React, { Component } from "react";
import { Spinner } from "reactstrap";
import swal from "sweetalert";
import CustomModal from "../../../components/WebsiteComponents/CustomModal";
import { axiosGet, axiosPost } from "../../../utils/AxiosApi";
import { fileUrl, moduleName, URL } from "../../../utils/Constants";
import {
  displayConfirmDeleteAlert,
  displayErrorAlert,
  DISPLAYMESSAGE,
} from "../../../utils/DisplayMessage";
import CreateTravelAgency from "./CreateTravelAgency";
import { checkRolePermissions } from "../../../utils/Helper";
import Pagination from "react-js-pagination";
import ViewTravelAgencyDetails from "./ViewTravelAgencyDetails";
import CustomFullSpinner from "../../../components/WebsiteComponents/CustomFullSpinner";
import { ThemeConsumer } from "styled-components";

class TravelAgency extends Component {
  state = {
    createModal: false,
    dataSpinner: false,
    deletePermission: false,
    edit: false,
    editPermission: false,
    selectedData: "",
    travelAgencies: [],
    viewDetailsModal: false,
    customersList: [],
    operatorList: [],
    current_page: 1,
    totalItemsCount: 0,
    paginated_value: 10,
  };

  componentDidMount() {
    this.getTravelAgencies();
    this.permissions();
  }

  getTravelAgencies = (pageNumber, paginated_value) => {
    let page = pageNumber || this.state.current_page
    let paginatedValue = paginated_value || this.state.paginated_value
    let param = {
      page: page,
      paginated_value: paginatedValue,
    }
    this.setState({ dataSpinner: true, travelAgencies: [] }, function () {
      axiosPost(
        URL.travelAgency + "/get-travel-agencies", param,
        (response) => {
          if (response.status === 200) {
            this.setState({
              travelAgencies: response.data.data.items,
              totalItemsCount: response.data.data.totalData,
              current_page: page,
              paginated_value:paginatedValue,
              dataSpinner: false,
            });
          }
        },
        (err) => {
          displayErrorAlert(err);
          this.setState({ dataSpinner: false });
        }
      );
    });
  };

  handleCreateModal = () => {
    this.setState({ createModal: !this.state.createModal, edit: false });
  };

  handleDeleteBtnClick = (id) => {
    displayConfirmDeleteAlert(id, this.handleDelete);
  };

  handleDelete = (id) => {
    this.setState(
      {
        spinner: true,
      },
      () => {
        axiosGet(
          URL.deleteTravelAgency + "/" + id,
          (response) => {
            if (response.status === 200) {
              this.setState({
                spinner: false,
              });
              swal("Success", DISPLAYMESSAGE.deleteSuccess, "success");
              this.getTravelAgencies();
            }
          },
          (err) => {
            displayErrorAlert(err);
            this.setState({
              spinner: false,
            });
          }
        );
      }
    );
  };

  handleEdit = (item) => {
    this.setState({ selectedData: item, edit: true, createModal: true });
  };

  permissions = () => {
    this.setState({
      editPermission: checkRolePermissions("update", moduleName.travelAgency),
      deletePermission: checkRolePermissions("delete", moduleName.travelAgency),
    });
  };

  getAllCustomers = (item, pageNumber) => {
    this.setState(
      {
        loader: true,
        customersList: [],
      },
      () => {
        axiosPost(
          URL.getAllCustomers + "?" + "page=" + pageNumber,
          { travel_agency_id: item?.id || this.state.activeDataId },
          (response) => {
            if (response.status === 200) {
              this.setState({
                loader: false,
                customersList: response.data.data.items,
              });
            }
          },
          (err) => {
            displayErrorAlert(err);
          }
        );
      }
    );
  };

  getAllOperators = (item, pageNumber = 1) => {
    this.setState(
      {
        loader: true,
        operatorList: [],
      },
      () => {
        axiosPost(
          URL.travelChildAgency + "?" + "page=" + pageNumber,
          { travel_agency_id: item?.id || this.state.activeDataId },
          (response) => {
            if (response.status === 200) {
              this.setState({
                loader: false,
                operatorList: response.data.data,
              });
            }
          },
          (err) => {
            displayErrorAlert(err);
          }
        );
      }
    );
  };

  handleViewDetails = (item, pageNumber) => {
    this.getAllCustomers(item, pageNumber);
    this.getAllOperators(item, pageNumber);

    this.setState({
      viewDetailsModal: true,
      activeDataId: item.id,
    });
  };

  toggleViewModal = () => {
    this.setState({
      viewDetailsModal: !this.state.viewDetailsModal,
    });
  };

  handlePaginatedValueChange = (value) => {
    let valuePage = parseInt(value);
    this.setState({ paginated_value: valuePage }, () => {
      this.getTravelAgencies(1, valuePage);
    });
  };


  render() {
    const { current_page, paginated_value, totalItemsCount } = this.state;
    return (
      <>
        {this.state.spinner ? (
          <CustomFullSpinner text="Processing ..."></CustomFullSpinner>
        ) : null}
        <div className="dashboardHeader">
          <strong>TRAVEL AGENCIES</strong>
        </div>
        <div className="container-fluid h-100">
          <div className="row mt-2">
            <div className="col">
              {checkRolePermissions("create", moduleName.travelAgency) ? (
                <button
                  className="btn btn-success"
                  onClick={this.handleCreateModal}
                >
                  Add Travel Agency
                </button>
              ) : null}
            </div>
          </div>
          <div className="row mt-2 h-100">
            <div className="col d-flex align-items-center justify-content-between flex-column">
              <div className="table-responsive w-100">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>S.N</th>
                      <th>Logo</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Contact Details</th>
                      <th>Email</th>
                      <th>URL</th>
                      {this.state.editPermission ||
                        this.state.deletePermission ? (
                        <th>Options</th>
                      ) : null}
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.travelAgencies?.length > 0 ? (
                      this.state.travelAgencies?.map((item, idx) => {
                        return (
                          item.is_operator === null && (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>
                                {item.media.length > 0 ? (
                                  <img
                                    src={
                                      fileUrl +
                                      "/" +
                                      item.media[0].id +
                                      "/" +
                                      item.media[0].file_name
                                    }
                                    className="logoDisplay"
                                  />
                                ) : null}
                              </td>
                              <td>{item.name}</td>
                              <td>{item.address}</td>
                              <td>{item.contact_details}</td>
                              <td>{item.email}</td>
                              <td>{item.front_end_url}</td>
                              {this.state.editPermission ||
                                this.state.deletePermission ? (
                                <td>
                                  <button
                                    className="btn btn-primary m-1"
                                    onClick={() => this.handleViewDetails(item)}
                                  >
                                    <i class="fa-solid fa-eye"></i>
                                  </button>

                                  {this.state.editPermission ? (
                                    <button
                                      className="btn btn-primary m-1"
                                      onClick={() => this.handleEdit(item)}
                                    >
                                      <i class="fa-solid fa-pen-to-square"></i>
                                    </button>
                                  ) : null}
                                  {this.state.deletePermission ? (
                                    <button
                                      className="btn btn-danger m-1"
                                      onClick={() =>
                                        this.handleDeleteBtnClick(item.id)
                                      }
                                    >
                                      <i class="fa-solid fa-trash"></i>
                                    </button>
                                  ) : null}
                                </td>
                              ) : null}
                            </tr>
                          )
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={
                            this.state.editPermission ||
                              this.state.deletePermission
                              ? 8
                              : 7
                          }
                          className="text-center p-3"
                        >
                          {this.state.dataSpinner ? (
                            <>
                              <Spinner color="primary"></Spinner>
                              <br />
                              Loading Data...
                            </>
                          ) : (
                            "No Travel Agency found. Create one first"
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {this.state.travelAgencies.total <= 10 ? (
                <></>
              ) : (
                <div className="m-4 d-flex justify-content-center">
                  <Pagination
                    activePage={current_page}
                    itemsCountPerPage={paginated_value}
                    totalItemsCount={totalItemsCount}
                    onChange={(pageNumber) =>
                      this.getTravelAgencies(pageNumber, paginated_value)
                    }
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="First"
                    lastPageText="Last"
                  />
                  <div className="paginatoion_paginated_value ml-3">
                    <select
                      className="form-control"
                      value={this.state.paginated_value}
                      onChange={(e) => this.handlePaginatedValueChange(e.target.value)}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={30}>30</option>
                      <option value={40}>40</option>
                      <option value={50}>50</option>
                    </select>
                  </ div>
                </div>
              )}
            </div>
          </div>

          <CustomModal
            modal={this.state.createModal}
            modalBody={
              <CreateTravelAgency
                getTravelAgencies={this.getTravelAgencies}
                handleCreateModal={this.handleCreateModal}
                selectedData={this.state.selectedData}
                edit={this.state.edit}
                page={current_page}
                paginatedValue={paginated_value}
                totalItems={totalItemsCount}

              />
            }
            modalHeader={
              this.state.edit ? "Edit Travel Agency" : "Add Travel Agency"
            }
            size="lg"
            toggleModal={this.handleCreateModal}
          ></CustomModal>

          <CustomModal
            fullWidth={true}
            modal={this.state.viewDetailsModal}
            modalBody={
              <ViewTravelAgencyDetails
                customersList={this.state.customersList}
                operatorList={this.state.operatorList}
                getAllCustomers={this.getAllCustomers}
                getAllOperators={this.getAllOperators}
                loader={this.state.loader}
              />
            }
            modalHeader="Details"
            size="lg"
            toggleModal={this.toggleViewModal}
          ></CustomModal>
        </div>
      </>
    );
  }
}

export default TravelAgency;
